export default {
  getShopName: (state) => (id) => {
    if (!id) return '';
    const shop = state.shops.find((s) => s.id === id);
    return shop?.name || '';
  },
};
